<template>
  <div>
    <h1 id="jump-to-header">{{heading || "View Asset to Image Link"}}</h1>
    <asset-image-link-show :id="id" :api_path="api_path"></asset-image-link-show>
  </div>
</template>

<script>
import AssetImageLinkShow from './AssetImageLinkShow.vue'

export default {
  components: {
    AssetImageLinkShow,
  },
  props: {
    id: {
      Type: String
    },
    heading: {
      Type: String
    },
    api_path: {
      Type: String
    }
  },
  data () {
    return {
    }
  },
  mounted() {
    const element = document.getElementById("jump-to-header")
    element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
  }
}
</script>
